import { render } from "./NavButton.vue?vue&type=template&id=5cd0a8d0&scoped=true&ts=true"
import script from "./NavButton.vue?vue&type=script&lang=ts"
export * from "./NavButton.vue?vue&type=script&lang=ts"

import "./NavButton.vue?vue&type=style&index=0&id=5cd0a8d0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\joaog\\Documents\\GitHub\\deadsouls-staking\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd0a8d0"]])

export default __exports__